module.exports = __webpack_public_path__ + "static/img/2.eb86aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/2.png
// module id = 7Y/m
// module chunks = 0